import React, {
  useRef,
  useState,
} from "react";

import {
  Send,
  CheckCircle2,
  AlertTriangle,
} from "lucide-react";

import "../components/contactForm.css";

const ContactForm = () => {

  const form = useRef();

  const BACKEND_URL =
    "https://rcsbackend.onrender.com";

  const [sending, setSending] =
    useState(false);

  const [status, setStatus] =
    useState("");

  const sendEmail =
    async (e) => {

    e.preventDefault();

    const formData =
      new FormData(form.current);

    const name =
      formData.get("name");

    const email =
      formData.get("email");

    const message =
      formData.get("message");

    const phone =
      formData.get("phone");

    try {

      setSending(true);

      const res =
        await fetch(
`${BACKEND_URL}/send-contact`,
{
  method: "POST",

  headers: {
    "Content-Type":
      "application/json",
  },

  body: JSON.stringify({
    name,
    email,
    phone,
    message,
  }),
}
);

      const data =
        await res.json();

      setSending(false);

      if (data.success) {

        setStatus("success");

        form.current.reset();

      } else {

        setStatus("failure");
      }

    } catch (err) {

      console.error(
        "❌ Server error:",
        err
      );

      setSending(false);

      setStatus("failure");
    }

    setTimeout(() => {
      setStatus("");
    }, 10000);
  };

  return (

    <div className="modern-contact-form-wrap">

      <form
        ref={form}
        onSubmit={sendEmail}
        className="modern-contact-form"
      >

        <div className="modern-contact-form-grid">

          <div className="modern-input-group">

            <label>
              Full Name
            </label>

            <input
              type="text"
              name="name"
              required
              placeholder="Enter your name"
            />

          </div>

          <div className="modern-input-group">

            <label>
              Contact Number
            </label>

            <input
              type="tel"
              name="phone"
              required
              placeholder="Enter your contact number"
            />

          </div>

        </div>

        <div className="modern-input-group">

          <label>
            Email Address
          </label>

          <input
            type="email"
            name="email"
            required
            placeholder="Enter your email"
          />

        </div>

        <div className="modern-input-group">

          <label>
            Message
          </label>

          <textarea
            name="message"
            required
            placeholder="Type your message here..."
            rows={6}
          />

        </div>

        <button
          type="submit"
          className="modern-contact-submit-btn"
        >

          {sending ? (
            <>
              <Send size={18} />
              Sending...
            </>
          ) : (
            <>
              <Send size={18} />
              Send Message
            </>
          )}

        </button>

      </form>

      {/* STATUS */}

      {status && (

        <div
          className={`modern-contact-status ${
            status
          }`}
        >

          {status ===
          "success" ? (
            <>
              <CheckCircle2 size={70} />

              <h3>
                Message Sent!
              </h3>

              <p>
                We’ll get back to you
                shortly.
              </p>
            </>
          ) : (
            <>
              <AlertTriangle size={70} />

              <h3>
                Failed To Send
              </h3>

              <p>
                Please try again later.
              </p>
            </>
          )}

        </div>
      )}

    </div>
  );
};

export default ContactForm;